function pmFormatFt(amount) {
  var rounded = Math.round(amount);
  return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Ft';
}

function pmRecentlyViewedCard(product) {
  var image = product.image || (product.featured_image && product.featured_image.url) || '';
  var imgWidth = (product.featured_image && product.featured_image.width) || 400;
  var imgHeight = (product.featured_image && product.featured_image.height) || 400;
  var priceText = '';
  if (typeof product.price === 'number') {
    priceText = pmFormatFt(product.price / 100);
  } else if (product.price) {
    var parsed = parseFloat(String(product.price).replace(/[^0-9.,]/g, '').replace(',', '.'));
    if (!isNaN(parsed)) priceText = pmFormatFt(parsed);
  }
  return (
    '<a href="' + product.url + '" class="pm-recently-viewed__card">' +
      (image ? '<img src="' + image + '" alt="" loading="lazy" width="' + imgWidth + '" height="' + imgHeight + '">' : '<div class="pm-recently-viewed__card-placeholder"></div>') +
      '<span class="pm-recently-viewed__title">' + product.title + '</span>' +
      (priceText ? '<span class="pm-recently-viewed__price">' + priceText + '</span>' : '') +
    '</a>'
  );
}

(function () {
  var container = document.getElementById('pm-recently-viewed');
  if (!container) return;

  var currentId = container.dataset.currentProductId;
  var viewedProducts = [];
  try {
    viewedProducts = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
  } catch (e) {
    viewedProducts = [];
  }

  viewedProducts = viewedProducts.filter(function (id) { return String(id) !== String(currentId); });

  if (!viewedProducts.length) return;

  var query = viewedProducts.map(function (id) { return 'id:' + id; }).join(' OR ');
  var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
    '&resources[type]=product&resources[limit]=' + viewedProducts.length;

  fetch(url)
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) return;

      var row = container.querySelector('.pm-recently-viewed__row');
      row.innerHTML = products.map(pmRecentlyViewedCard).join('');
      container.hidden = false;
    })
    .catch(function () {
      container.hidden = true;
    });
})();
